// extracted by mini-css-extract-plugin
export default {"orderDetails":"style--orderDetails--d371f8","info":"style--info--5f89ea","downloadPdf":"style--downloadPdf--d7a7d4","label":"style--label--d161b6","value":"style--value--45e8a9"};